import React from "react";
import { Alert } from "react-bootstrap";

export const EstadoCarregando: React.FC<{ texto: string }> = ({ texto }) => (
  <div className="text-center py-4">
    <div className="spinner-border spinner-border-sm text-primary" role="status">
      <span className="visually-hidden">Carregando...</span>
    </div>
    <p className="mt-2 mb-0 text-muted">{texto}</p>
  </div>
);

export const EstadoVazio: React.FC<{ texto: string }> = ({ texto }) => (
  <div className="text-center py-4 text-muted">
    <i className="mdi mdi-message-text-outline" style={{ fontSize: "36px" }}></i>
    <p className="mt-2 mb-0">{texto}</p>
  </div>
);

export const EstadoErro: React.FC<{ mensagem: string }> = ({ mensagem }) => (
  <Alert variant="danger" className="mb-0">
    <i className="mdi mdi-alert-circle-outline me-1"></i>
    {mensagem}
  </Alert>
);
